<template>
  <kanbanTable :columns="columns" :data="tableData"></kanbanTable>
</template>
<script>
import pencer from "./percent";
import kanbanTable from "../lytable.vue"
export default {
  components: {
    pencer, kanbanTable
  },
  data() {
    return {
      searchItem: {
        endTime: "",
        pageNumber: 1,
        pageSize: 50,
        sort: 2,
        startTime: "",
      },
      animate: false,
      percent: [],
      big: 20,
      columns: [
        {
          title: '车牌号',
          key: 'cset'
        },
        {
          title: '出发地',
          key: 'cset'
        },
        {
          title: '目的地',
          key: 'cset'
        },
        {
          title: '趟次状态',
          key: 'cset'
        }
      ],
      tableData: []
    };
  },
  methods: {
    reach(v) {
      this.searchItem.startTime = v.start - 86400000;
      this.searchItem.endTime = v.end - 86400000;
      return;
      this.getData();
    },
    getGroupList() {
      this.utils.loading(this, "加载中");
      this.axios({
        method: "post",
        url: this.axios.bm + "/group/list",
        data: {},
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        var data = res.data.data.dataList;
        var arr = [];
        for (let i = 0; i < data.length; i++) {
          arr.push(data[i].id);
        }
        this.searchItem.groupIdList = arr;
        this.getData();
      });
    },
    getData(v) {
      this.utils.loading(this, "加载中");
      this.axios({
        method: "post",
        url: this.axios.ipPort + "/cloud-car-server-upf/data/countAlarmTrend",
        data: this.searchItem,
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        var data = res.data.data;
        var time = data.dateList;
        for (let j = 0; j < time.length; j++) {
          time[j] = this.utils.time(time[j], "mmdd");
        }
        this.item = data;
        this.drawBar();
      });
    },
    drawBar() {
      this.chart = this.echarts.init(
        document.getElementById("baojingqushi"),
        "dark"
      );

      this.option = {
        backgroundColor: "",
        grid: {
          x: 30,
          y: 30,
          x2: 30,
          y2: 60, //距离下边的距离

        },
        /* dataZoom: [
          {
            type: "inside",
            //type: "slider",
            start: 0, //放大起点
            //end: this.list.length<500?100:100/(this.list.length/500) //放大终点
            end: 100, //放大终点
          },
        ], */
        xAxis: {
          type: "category",

          data: this.item.dateList,
          axisLabel: { rotate: 45, color: "#999" },
          axisLine: {
            lineStyle: {
              color: "#999", //线条颜色
            },
          },
          axisTick: {
            show: true,
            lineStyle: {
              color: "#999", //线条颜色
            },
          },
        },
        yAxis: {
          type: "value",
          axisLabel: { rotate: 0, color: "#999" },
          axisLine: {
            lineStyle: {
              color: "#999", //线条颜色
            },
          },
          axisTick: {
            show: true,
            lineStyle: {
              color: "#999", //线条颜色
            },
          },
        },
        color: ["#5fc6ec", "yellow"],
        series: [
          {
            data: this.item.alarmList,
            type: "line",
            smooth: 0.5,
            // 设置折线上圆点大小
            symbolSize: 16,
            label: {
              show: true,
              position: "top",
            },
            itemStyle: {
              normal: {
                // color: "#6cb041",
                lineStyle: {
                  width: 2, //设置线条粗细
                },
              },
            },
            /* areaStyle: {
              //color: "#ff7c25",
              opacity: "0.9",
              //shadowColor: "#000",
              // shadowBlur: 50,
              //shadowOffsetX:0,
              // shadowOffsetY:-10
              color: new this.echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: "#0b0b60",
                },
                {
                  offset: 1,
                  color: "#000001",
                },
              ]),
            }, */
          },
        ],
        tooltip: {
          //工具提示
          left: 20,
          formatter: function (val) {
            return val.name + "（" + val.value + "）";
          },
        },
      };
      this.chart.setOption(this.option);
      this.chart.resize();
    },

  },
};
</script>
<style>
#baojingqushi {
  width: 100%;
  height: 100%;
}
</style>


// WEBPACK FOOTER //
// src/components/kanban/tangci/youhao.vue